import { render, staticRenderFns } from "./MessageDrawer.vue?vue&type=template&id=df225b8c&scoped=true&"
import script from "./MessageDrawer.vue?vue&type=script&lang=js&"
export * from "./MessageDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MessageDrawer.vue?vue&type=style&index=0&id=df225b8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df225b8c",
  null
  
)

export default component.exports